import { toast } from "react-toastify";

export const errorToast = (message) => {
  toast.error(<div>{message}</div>, {
    hideProgressBar: true,
    autoClose: 2987,
  });
};

export const updateSuccessfulToast = (message) => {
  toast.success(message);
};

export const accountDeletedToast = () => {
  toast.success(<div>User Account Deleted</div>, {
    hideProgressBar: true,
    autoClose: 2987,
  });
};

export const messageSentToast = () => {
  toast.success("Message Sent");
};

export const successfulToast = (message) => {
  toast.success(<div>{message}</div>, {
    hideProgressBar: true,
    autoClose: 2987,
  });
};

export const confirmToast = (
  message,
  { confirmText = "Reassign", cancelText = "Cancel" } = {}
) =>
  new Promise((resolve) => {
    const toastId = toast.info(
      <div>
        <div style={{ marginBottom: "8px" }}>{message}</div>
        <div style={{ display: "flex", gap: "8px" }}>
          <button
            type="button"
            onClick={() => {
              toast.dismiss(toastId);
              resolve(true);
            }}
            style={{
              border: "1px solid var(--primary-color, #3b82f6)",
              background: "var(--primary-color, #3b82f6)",
              color: "#fff",
              padding: "6px 10px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            {confirmText}
          </button>
          <button
            type="button"
            onClick={() => {
              toast.dismiss(toastId);
              resolve(false);
            }}
            style={{
              border: "1px solid var(--border-color, #d0d5dd)",
              background: "transparent",
              color: "inherit",
              padding: "6px 10px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            {cancelText}
          </button>
        </div>
      </div>,
      {
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        draggable: false,
        hideProgressBar: true,
      }
    );
  });
